import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconScrewdriverInHandBlack({
	size = "100",
	...props
}: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path id="a" d="m6.516 17.362 1.362-6.11 5.194.495.016 5.615z" />
			</defs>
			<g fill="none" fillRule="evenodd">
				<path
					fill="#000"
					d="M10.482 5.905 5.449 4.333l-.678-.546-1.852-.234-.226.687 1.54.875 1.055.01 4.968 1.65z"
				/>
				<g transform="translate(2.515 3.325)">
					<path
						fill="#000"
						d="m10.052 2.45-1.294-.193s-.494-.037-.786 1.378c-.382 1.852-.235 1.763-.235 1.763l.6 2.792.093 1.272-.399.598.039.772 4.939.42.089-1.507 1.354-.86.604-.577.471-1.63 1.419.452 1.13.093.723-1.08-.391-.862-.619-.303-1.577-.342.246-.998-.506-.846-.942.21-.391-.872-1.152-.05-.751-.278-1.092-.06s-.003.336-.084.133c-.24-.609-.314-.56-.314-.56l-.745-.173-.624.412-.077.573.272.324Z"
					/>
					<path
						fill="#CD0400"
						d="m16.873 6.95-3.438-1.124a.45.45 0 0 1 .47-.124l2.66.869a.45.45 0 0 1 .308.379m1.95-1.416a1.43 1.43 0 0 0-.847-.701l-1.668-.546-.094.364 1.27.415a.45.45 0 0 1-.472.124l-.864-.282-.093.364.842.275a.824.824 0 0 0 .96-.359l.004.001c.554.181.846.708.678 1.226a1.02 1.02 0 0 1-1.29.658l-.003-.001a.83.83 0 0 0-.566-.858l-1.05-.343a.59.59 0 0 1-.69-.226l-.919-.3a.82.82 0 0 0-.958.355 1.02 1.02 0 0 1-.47-.414 1.59 1.59 0 0 0-1.75-.824l.067-.207-.363-.093-.187.575c-.02.064-.02-.145-.084-.166l-.111.005c-.064-.022-.147.12-.128.055l.167-.516a1 1 0 0 0-.465.138l-.005.004.028.01-.08.248a.5.5 0 0 0 .03.38c.059.117-.001-.122.124-.081l.13-.074c.235-.083.508.075.611-.158.59-.257 1.396.31 1.689.884a1.4 1.4 0 0 0 .773.626l4.095 1.337a1.39 1.39 0 0 0 1.76-.898c.11-.329.085-.687-.071-.997M3.062.802 2.377.305a.2.2 0 0 0-.082-.033L.44.002a.186.186 0 0 0-.204.127l-.227.7a.19.19 0 0 0 .09.223l1.658.878a.2.2 0 0 0 .086.022l.846.003 5.534 1.808.091-.364-5.538-1.81a.2.2 0 0 0-.057-.01l-.828-.002L.413.794l.13-.399 1.653.24.671.488a.2.2 0 0 0 .052.026l5.554 1.815a.9.9 0 0 1 .3-.296z"
					/>
					<path fill="#CD0400" d="m14.579 3.723-.093.363.601.197.093-.364z" />
					<path
						fill="#CD0400"
						d="m16.394 3.95-.081.316-.002.009-.303 1.182a.595.595 0 0 1-.727.43.6.6 0 0 1-.428-.729l.077-.299q.027-.07.047-.147l.298-1.161a.594.594 0 0 1 .69-.33.6.6 0 0 1 .429.73Zm-1.027 3.015-.271 1.01c-.078.299-.24.496-.528.769l-1.773 1.135a.3.3 0 0 0-.108.118l-4.044-.411.074-.362a.3.3 0 0 0 .008-.069V9.15a.3.3 0 0 0-.007-.058l-.7-3.777a1.4 1.4 0 0 1-.013-.657l.001-.011.008-.032.342-1.37.004-.017a.95.95 0 0 1 .27-.45l.009-.009a.87.87 0 0 1 .811-.207l.053.014h.002l1.782.46h.002l.253.064a.46.46 0 0 1 .327.317.5.5 0 0 1 .008.282l-.07.275-.004.012v.001l-.003.01-.001.003-.003.008v.003l-.004.01-.004.01-.003.007-.001.003a.49.49 0 0 1-.42.308.5.5 0 0 1-.138-.014l-.74-.19a.97.97 0 0 0-.743.108c-.23.138-.394.358-.462.62a.31.31 0 0 0 .04.253l.01.015a2 2 0 0 1 .247.437c.141.35.165.725.073 1.134a.311.311 0 1 0 .606.138q.092-.412.062-.797c-.012-.051-.172-.721-.32-1.026l-.068-.11a.4.4 0 0 1 .13-.128.35.35 0 0 1 .27-.04l.74.19q.116.03.231.034a1.22 1.22 0 0 0 1.393.006 1.23 1.23 0 0 0 1.543.575c.046.223.153.429.307.593 0 0 .38.31.888.339zm-2.53 4.133L8.24 10.66l.05-.483 4.593.467-.045.454Zm-2.815-9.29a.61.61 0 1 1 1.181.306l-.061.239-1.182-.304zm2.386 2.32.07-.274a1 1 0 0 0 .023-.11c.04-.26-.009-.52-.142-.747l-.007-.012-.002-.003-.008-.013-.004-.006q0-.002-.003-.005l-.004-.006-.004-.005-.003-.006-.004-.005-.004-.006-.007-.01-.004-.006-.004-.005-.008-.01-.004-.006-.003-.005-.005-.006-.003-.004-.005-.006-.003-.004-.005-.006-.003-.005-.005-.005-.003-.004-.005-.006-.004-.004-.005-.006-.004-.005-.021-.023-.006-.007-.003-.003-.006-.006-.003-.003-.005-.005-.004-.004-.005-.006-.01-.009-.004-.003-.005-.005-.004-.004-.005-.005-.004-.004-.006-.005-.004-.003-.005-.005-.004-.003-.006-.005-.004-.004-.006-.005-.004-.003-.006-.005-.004-.004-.006-.004-.004-.003-.006-.005-.003-.002-.01-.008-.007-.005-.004-.003-.006-.005q-.003 0-.005-.003l-.006-.004-.004-.003-.006-.004-.011-.008q-.002 0-.005-.003l-.006-.003-.005-.004-.005-.003-.006-.004-.005-.003-.005-.003-.006-.004-.006-.003-.006-.003q-.002-.002-.005-.003l-.006-.004-.005-.003-.007-.004-.004-.002-.007-.004-.004-.002-.009-.004-.002-.002-.01-.005h-.002l-.049-.024-.01-.004h-.002l-.011-.005h-.001l-.011-.005h-.002l-.01-.005h-.002l-.01-.004-.003-.001-.01-.004h-.002l-.011-.005h-.001l-.029-.01.048-.184a.607.607 0 0 1 .742-.44.613.613 0 0 1 .452.682l-.014.05-.38 1.48q-.008.034-.015.067a.6.6 0 0 1-.362.367c.087-.116.154-.251.193-.402m1.167-1.343.015-.067a.606.606 0 0 1 .726-.386.613.613 0 0 1 .439.745l-.07.273a1 1 0 0 0-.048.146L14.34 4.66a.61.61 0 0 1-.707.338.613.613 0 0 1-.45-.682l.013-.05.38-1.48Zm2.546-.167a1.2 1.2 0 0 0-.753.047 1.24 1.24 0 0 0-.897-.937 1.22 1.22 0 0 0-1 .174 1.23 1.23 0 0 0-.781-.622 1.22 1.22 0 0 0-.965.152 1.23 1.23 0 0 0-2.305.22l-.067.263a1.5 1.5 0 0 0-.886.21c-.477.296-.668.815-.668.815s-.15.569-.335 1.309a3.2 3.2 0 0 0-.055 1.19l.688 3.713-.078.385a.396.396 0 0 0-.325.35l-.074.731a.4.4 0 0 0-.311.312l-1.317 6.158c-.042.205-.078.532.082.665.208.173.39.155.642.16h6.667a.56.56 0 0 0 .326-.508l-.002-.804a.311.311 0 1 0-.622.002l.002.639-6.503.046 1.294-6.036 5.194.495.01 3.36a.311.311 0 1 0 .62-.002l-.009-3.563a.4.4 0 0 0-.239-.365l.07-.697a.4.4 0 0 0-.077-.279l1.48-.947a.3.3 0 0 0 .044-.035c.309-.29.596-.59.725-1.083l.279-1.037s.129-.432-.089-.658l.042-.018a1.21 1.21 0 0 0 .682-.811l.229-.894.18-.727a1.224 1.224 0 0 0-.898-1.373"
					/>
					<mask id="b" fill="#000">
						<use xlinkHref="#a" />
					</mask>
					<use xlinkHref="#a" fill="#000" />
					<g fill="#CD0400" mask="url(#b)">
						<path d="m7.727 13.57.914-.408.407.914-.914.407z" />
						<path d="m7.015 13.886.913-.406.407.913-.913.407zm1.425-.634.914-.407.406.914-.913.407z" />
						<path d="m9.153 12.935.913-.407.407.914-.914.406z" />
						<path d="m9.865 12.617.914-.406.406.913-.913.407z" />
						<path d="m10.578 12.3.913-.407.407.914-.914.407z" />
						<path d="m11.29 11.983.914-.407.407.914-.914.406z" />
						<path d="m12.003 11.666.913-.407.407.913-.913.407zm-3.706 3.182.913-.407.407.914-.913.407z" />
						<path d="m7.584 15.165.914-.406.407.913-.914.407zM6.16 15.8l.913-.407.406.914-.913.406z" />
						<path d="m6.872 15.483.913-.407.407.913-.913.407zm2.138-.953.913-.406.407.914-.914.406z" />
						<path d="m9.722 14.214.914-.407.406.913-.913.407z" />
						<path d="m10.435 13.896.913-.406.407.913-.914.407z" />
						<path d="m11.147 13.58.914-.408.406.914-.913.407z" />
						<path d="m11.86 13.262.913-.407.407.914-.914.406z" />
						<path d="m12.572 12.945.914-.407.407.913-.914.407zm-4.437 3.508.914-.407.407.913-.914.407z" />
						<path d="m7.423 16.77.913-.407.407.914-.913.406zm-1.425.634.913-.406.407.913-.913.407z" />
						<path d="m6.71 17.087.914-.407.407.914-.914.407zm2.138-.952.914-.406.406.913-.913.407z" />
						<path d="m9.56 15.818.914-.407.407.914-.914.407z" />
						<path d="m10.273 15.5.914-.406.406.914-.913.406z" />
						<path d="m10.986 15.184.913-.407.407.913-.914.407z" />
						<path d="m11.698 14.866.914-.406.407.913-.914.407z" />
						<path d="m12.41 14.549.914-.407.407.914-.913.407zm-2.993 2.865.914-.406.407.913-.914.407z" />
						<path d="m10.13 17.097.914-.407.406.914-.913.407z" />
						<path d="m10.843 16.78.913-.407.407.914-.914.406z" />
						<path d="m11.555 16.462.914-.406.406.913-.913.407z" />
						<path d="m12.268 16.145.913-.407.407.914-.914.407zm-5.11-3.855.914-.406.406.913-.913.407z" />
						<path d="m7.87 11.973.914-.407.407.914-.914.407z" />
						<path d="m8.583 11.656.914-.407.406.914-.913.406z" />
						<path d="m9.296 11.338.913-.406.407.913-.914.407z" />
						<path d="m10.008 11.021.914-.407.407.914-.914.407z" />
					</g>
				</g>
			</g>
		</svg>
	);
}
